<template>
    <m-pageframe
        title="RedChirp Tuning Knobs"
    >
    <v-container
        fluid
        style="padding: 15px"
    >
    
        <!-- <v-text-field
            label="Search"
            prepend-icon="mdi-magnify"
            v-model="full_text"
            v-on:input="update"
            autocomplete="off"
            autofocus
            append-icon="mdi-reload"
            v-on:click:append="update"
    
        >
        </v-text-field> -->
               
    
        <v-data-table
            v-if="results != null"
            :headers="headers"
            :items="merged_results"
            :items-per-page="100"
            class="elevation-1"
            :hide-default-footer="true"
            :footer-props="{
                disableItemsPerPage: false,
                disablePagination: false,
            }"
            :search="full_text"
        >
        
            <template v-slot:item.code="{ item }">
                <span style="font-family: monospace">{{item.code}}</span>
            </template>
    
            <template v-slot:item.process_state="{ item }">
                {{prettyState(item.process_state)}}
            </template>
    
            <template v-slot:item.action="{ item }">
                <v-menu 
                    bottom 
                    offset-y  
                >
                
                <template v-slot:activator="{ on }">
                        
                    <v-icon 
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                        
                </template>
                
                <v-list>
                    <v-list-item
                        v-on:click="onClickSetValue(item)"
                    >
                        <v-list-item-title>Set Value...</v-list-item-title>
                    </v-list-item>
                
                </v-list>
                
                </v-menu> 
            </template>
        
        </v-data-table>
    
    </v-container>
    </m-pageframe>
    </template>
    
    <script>
    const Time = require('@/js/time.js');
    export default {
    data() {
        return {
            results: [],
            full_text: null,
            include_tasks: true,
            include_processors: true,
    
            headers: [
                { text: 'Code', value: 'code'},
                { text: 'Description', value: 'description'},
                { text: 'Expiration', value: 'expiration'},
                { text: 'Default Value', value: 'default_value_as_string'},
                { text: 'Current Value', value: 'value_as_string'},
                { text: 'Action', value: 'action'},
                ],
        }
    },
    
    mounted () {
        this.update();
    },
    
    methods: {
        update()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/admin/knob',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list tuning knobs',
            });
        },
    
        onClickSetValue(item)
        {
            this.$rc.prompt({
                'title': 'Set Value: '+item.code,
                'label' : item.description,
                'value' : item.value_as_string,
                'after_prompt' : (value) => {
                    this.$rc.rest({
                        'spinner': true,
                        'endpoint': 'PUT: /api/v1/admin/knob/:code',
                    
                        'params' : {
                                'code': item.code,
                                'value': value,
                            },
                    
                        'on_success': (data) => {
                                this.update();
                            },
                    
                        'on_error': 'Unable to set value',
                    });
                }
            });
        },
    },
    
    computed: {
        merged_results() {
            let ret = [];

            if ( this.results == null ) return ret;

            for ( let i = 0; i < this.results.length; i++ )
            {
                let knob = this.results[i];

                let knob_definition = this.$rc.enumObject('knob_definition', knob.code);

                knob.description = knob_definition?.text;
                knob.expiration = knob_definition?.expiration;
                knob.default_value_as_string = knob_definition?.default_value_as_string;

                ret.push(knob);
            }

            return ret;
        }
    },
    }
    </script>
    
    <style lang="scss" scoped>
    </style>